/**
 * Whether this build runs against MSW mocks or the real API.
 *
 * Default is *mocks*: the console's acceptance bar (05-risks-and-verification.md W1-F)
 * is that every screen works end-to-end with zero backend running, and that has to hold
 * for the static build the e2e suite serves. A production deployment sets
 * `VITE_API_MODE=live` at build time; the UI shows a MOCK DATA banner whenever this is
 * false, so nobody mistakes demo data for a live account.
 */
export function isMockEnabled(): boolean {
  const mode = (import.meta.env.VITE_API_MODE as string | undefined) ?? 'mock'
  return mode !== 'live'
}
